import { fromJS } from 'immutable';

// eslint-disable-next-line import/prefer-default-export
export const handleSetPassengers = (state, passengers) => {
  // Passengers are already normalized in setPassengers action (before camelizeKeys)
  return state.merge({
    savingPassengers: false,
    passengers: fromJS(passengers),
  });
};
